import * as React from 'react';
import clsx from 'clsx';
import docIcon from '@/assets/images/svg/doc_icon.svg';

interface FileUploadAreaProps {
  onFileSelect: (file: File) => void;
}

export const FileUploadArea: React.FC<FileUploadAreaProps> = ({ onFileSelect }) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files.item(0);
      if (file) {
        onFileSelect(file);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files.item(0);
      if (file) {
        onFileSelect(file);
        // Reset so re-selecting the same file fires onChange again.
        e.target.value = '';
      }
    }
  };

  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center text-center',
        'mx-auto h-[157px] w-full max-w-[382px]',
        'rounded-20',
        'bg-white/40 backdrop-blur-sm',
        'transition-colors hover:bg-white/60',
        'cursor-pointer'
      )}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%2345349E' stroke-width='1' stroke-dasharray='28%2c 28' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
    >
      <input
        type='file'
        ref={inputRef}
        className='hidden'
        onChange={handleChange}
        accept='.mp4,.mov,.mp3,.wav,.jpg,.png,.webp,.pdf,.docx'
      />

      {/* Doc Icon */}
      <div className='mb-4'>
        <img src={docIcon} alt='' className='size-10 object-contain' />
      </div>

      <p className='mb-2 font-sans text-20 font-medium leading-27 text-brand-800'>
        Drag & Drop or{' '}
        <span className='text-brand-600 underline decoration-solid'>Choose File</span>
      </p>

      <div className='px-4 text-center font-sans text-11 font-normal leading-[18px] text-gray-490'>
        <p>Videos, Audio, Images, Documents</p>
        <p>Limits: Video 500MB · Audio 100MB · Doc 50MB · Image 20MB</p>
      </div>
    </div>
  );
};
